import React from "react";
import chart from '../Images/Chart.png'
import settings from '../Images/Settings.png'
import search from '../Images/Search.png'
import cart from '../Images/Cart.png'
import puzzle from '../Images/Puzzle.png'
import timer from '../Images/Timer.png'
import { motion } from "framer-motion";
import {FaArrowRight } from "react-icons/fa";
import { Link } from "react-router-dom";
import fashion from '../Images/Logo1.png'
import fashio from '../Images/Logo2.png'
import fashi from '../Images/Logo3.png'
import fash from '../Images/Logo4.png'
import fas from '../Images/Logo5.png'
import fa from '../Images/Logo6.png'




const Secone = () => {

    const comprehensive ={
        background: '#EEEE',
        padding: '10px',
    }

    const glideUp = {
        initial: { opacity: 0, y: 60 },
        whileInView: { opacity: 1, y: 0 },
        transition: { duration: 0.8 },
        viewport: { once: true }
    };

    return(
        <>
        <div style={{background: '#EEEE', color: '#EEEE'}}>
            <h1 className="p-5">content</h1>
        </div>
        <div className="container">
        <div className="row text-center logos-row">
            <div className="col-6 col-md p-4"><img src={fashio} style={{width: '90px'}} alt="" /></div>
            <div className="col-6 col-md p-4"><img src={fashion} style={{width: '90px'}} alt="" /></div>
            <div className="col-6 col-md p-4"><img src={fashi} style={{width: '70px'}} alt="" /></div>
            <div className="col-6 col-md p-4"><img src={fash} style={{width: '70px'}} alt="" /></div>
            <div className="col-6 col-md p-4"><img src={fas} style={{width: '90px'}} alt="" /></div>
            <div className="col-6 col-md p-4"><img src={fa} style={{width: '90px'}} alt="" /></div>
        </div>
        </div>

        <div style={comprehensive}>
        <div className="container">
            <div className="row mt-5">
                <div className="col-md-12 mb-4 text-center">
                    <h2 style={{fontWeight: '700'}}><span style={{color: '#353995'}}>WHAT’S</span> <span style={{color: '#F29235'}}>INCLUDED</span></h2>
                    <p className="mt-3">A comprehensive approach to web development, ensuring very aspect of <br /> your digital presence is optimized for success</p>
                </div>
            </div>

            <div className="row g-4">
                <div className="col-md-4">
                    <motion.div {...glideUp}>
                        <div className="card hover-card">
                        <img src={chart} alt="" className="img-fluid img" />
                        <h1 className="mt-4 title">UI/UX Design</h1>
                        <p className="mt-4">
                        User-centric interfaces built for conversion...
                        </p>

                        <motion.div whileHover={{ y: -5 }} transition={{ type: "spring", stiffness: 400, damping: 10 }}>
                        <Link to="/about" className="mt-4 learn-more d-inline-flex align-items-center gap-2">
                            Learn more <FaArrowRight />
                        </Link>
                        </motion.div>
                        </div>
                    </motion.div>
                </div>

                <div className="col-md-4">
                    <motion.div {...glideUp}>
                        <div className="card hover-card">
                        <img src={settings} alt="" className="img-fluid img" />
                        <h1 className="mt-4 title">Backend Engineering</h1>
                        <p className="mt-4">
                        Robust, secure, and scalable server-side
                        </p>
  
              <motion.div whileHover={{ y: -5 }} transition={{ type: "spring", stiffness: 400, damping: 10 }}>
              <Link to="/about" className="mt-4 learn-more d-inline-flex align-items-center gap-2">
                  Learn more <FaArrowRight />
              </Link>
              </motion.div>
                        </div>
                    </motion.div>
                </div>

                <div className="col-md-4">
                    <motion.div {...glideUp}>
                        <div className="card hover-card">
                        <img src={search} alt="" className="img-fluid img" />
                        <h1 className="mt-4 title">SEO Optimization</h1>
                        <p className="mt-5">
                        Search engine ready from day one
                        </p>

            <motion.div whileHover={{ y: -5 }} transition={{ type: "spring", stiffness: 400, damping: 10 }}>
            <Link to="/about" className="mt-4 learn-more d-inline-flex align-items-center gap-2">
                Learn more <FaArrowRight />
            </Link>
            </motion.div>
                        </div>
                    </motion.div>
                </div>

                <div className="col-md-4 pb-5">
                    <motion.div {...glideUp}>
                        <div className="card hover-card">
                        <img src={cart} alt="" className="img-fluid img" />
                        <h1 className="mt-3 title">E-commerce</h1>
                        <p className="mt-4">
                        Secure payment integrations and custom
                        </p>

            <motion.div whileHover={{ y: -5 }} transition={{ type: "spring", stiffness: 400, damping: 10 }}>
            <Link to="/about" className="mt-4 learn-more d-inline-flex align-items-center gap-2">
                Learn more <FaArrowRight />
            </Link>
            </motion.div>
                        </div>
                    </motion.div>
                </div>

                <div className="col-md-4 pb-5">
                    <motion.div {...glideUp}>
                        <div className="card hover-card">
                        <img src={puzzle} alt="" className="img-fluid img" />
                        <h1 className="mt-3 title">API Integration</h1>
                        <p className="mt-4">
                        Connecting your website with CRM, ERP
                        </p>

            <motion.div whileHover={{ y: -5 }} transition={{ type: "spring", stiffness: 400, damping: 10 }}>
            <Link to="/about" className="mt-4 learn-more d-inline-flex align-items-center gap-2">
                Learn more <FaArrowRight />
            </Link>
            </motion.div>
                        </div>
                    </motion.div>
                </div>

                <div className="col-md-4 pb-5">
                    <motion.div {...glideUp}>
                        <div className="card hover-card">
                        <img src={timer} alt="" className="img-fluid img" />
                        <h1 className="mt-3 title">Performance Tuning</h1>
                        <p className="mt-4">
                        Sub-second load times and global CDN
                        </p>

                    <motion.div whileHover={{ y: -5 }} transition={{ type: "spring", stiffness: 400, damping: 10 }}>
                    <Link to="/about" className="mt-4 learn-more d-inline-flex align-items-center gap-2">
                        Learn more <FaArrowRight />
                    </Link>
                    </motion.div>
                        </div>
                    </motion.div>
                </div>


        
                </div>
        </div>            
        </div> 



        </>
    )
} 


export default Secone;